import React, { useState, useEffect } from "react";
import ct from "class-types.macro";

const ChatLink = ({ productListingView }: { productListingView?: string }) => {
  const [currentUrl, setCurrentUrl] = useState("");

  useEffect(() => {
    setCurrentUrl(window.location.pathname);
  }, []);

  const handleChatLinkClick = (event: React.SyntheticEvent) => {
    event.preventDefault();

    window.open(
      `/chat/?referringURL=${encodeURIComponent(currentUrl)}`,
      "",
      "width=650,height=700,resizable=1,scrollbars=1",
    );
  };

  return (
    <a
      href={`/chat/?referringURL=${encodeURIComponent(currentUrl)}`}
      onClick={handleChatLinkClick}
      target="_blank"
      className={ct(
        "block",
        "text-green-500",
        "hover:text-green-900",
        "no-underline",
        productListingView === "list" ? ct("leading-4", "pb-2") : "",
      )}
    >
      Start a Live Chat
    </a>
  );
};

export default ChatLink;
